import getFilterValue from './getFilterValue';
import getOperator from './getOperator';

const getCustomFiltersAsQueryParams = (customFilterSet, reportKeys = []) => {
    if (
        !customFilterSet ||
        customFilterSet.length === 0 ||
        (customFilterSet.length === 1 && customFilterSet[0].value === '') ||
        (customFilterSet.length === 1 && customFilterSet[0].value === '.')
    ) {
        return '';
    }

    // We need to make sure the custom filter key is actually part of the report keys
    let expressionArray = customFilterSet
        .filter((filter) => filter.value !== '' && filter.value !== '.' && reportKeys.includes(filter.measure))
        .map((filter) => {
            const operator = getOperator(filter.operator);
            const value = getFilterValue(filter);
            return `${filter.measure}${operator}${value}`;
        });

    // If the custom filters include anything about draft, auto set draft round to >= 1
    const isThereDraftYearOrPickFilterSet = expressionArray.some(
        (str) => str.includes('draftYear') || str.includes('playerDraftOverallPickNo'),
    );
    const isThereDraftRoundFilterSet = expressionArray.some((str) => str.includes('draftRound'));

    if (isThereDraftYearOrPickFilterSet && !isThereDraftRoundFilterSet) {
        expressionArray = [...expressionArray, 'draftRound>=1'];
    }

    return `factCayenneExp=${expressionArray.join(' and ')}`;
};

export default getCustomFiltersAsQueryParams;
